import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Typography, Grid, Button} from "@material-ui/core"; // Importado o Grid aqui
import SpacerComponent
    from "../../../../Components/SpacerComponent/SpacerComponent";
import {ContentItemListMeta, DividerStyled} from "../styled";
import CampaignMetaScreen from "../CampaignMetaScreen";

class ContentListMeta extends Component {
    render() {

        const {metaData} = this.props;

        const lista = metaData && metaData.data ? metaData.data : [];

        return (
            <Grid container={true} spacing={3}>
                {lista.map((item, index) => (
                    <Grid item={true} xs={12} sm={6} md={4}
                          key={item.id || index}>
                        <ContentItemListMeta>
                            <Typography variant={'subtitle1'}>
                                {item.goal_title || 'Nome da meta'}
                            </Typography>

                            <SpacerComponent height={20}/>

                            <Typography variant={'subtitle1'}>
                                Periodo: {this.periodToHuman(item)}
                            </Typography>

                            <Typography variant={'subtitle1'}>
                                {this.statusToHuman(item).title}
                            </Typography>
                            <SpacerComponent height={20}/>
                            <DividerStyled/>
                            <Button variant={'text'}
                                    color={'primary'}
                                    size={"large"}
                                    fullWidth={true}
                                    onClick={() => {
                                        window.location.href = `${CampaignMetaScreen.ROUTE}/${item.uuid}`;
                                    }}>
                                {item.status === 'draft' ? 'Editar' : 'Visualizar'}
                            </Button>
                        </ContentItemListMeta>
                    </Grid>
                ))}
            </Grid>
        );
    }

    statusToHuman(item) {
        const statusMap = {
            draft: {
                title: 'Status atual: Rascunho',
                description: 'Nesse status a meta ainda pode ser alterada ou excluída.',
            },
            published: {
                title: 'Status atual: Publicada',
                description: 'Meta não pode mais ser alterada ou excluída.',
            },
            closed: {
                title: 'Status atual: Fechada',
                description: 'Meta não pode mais ser alterada ou excluída.',
            },
        };

        const currentStatus = item?.status;
        return statusMap[currentStatus] || false;
    }

    periodToHuman(item) {
        if (!item?.targets?.[0].period) {
            return '';
        }

        if (item?.targets?.[0].period === 'monthly') {
            return 'Mensal';
        }

        return 'Semanal';

    }
}

ContentListMeta.propTypes = {
    metaData: PropTypes.shape({
        data: PropTypes.arrayOf(PropTypes.object)
    })
};

ContentListMeta.defaultProps = {
    metaData: {
        data: []
    }
};

export default ContentListMeta;